export const deselectDocument = () => {
  return {
    type: 'DOCUMENT_DESELECT',
  };
};
